// Telegram keeps a Mini App running in the background, so a player can be on an old version long after a deploy.
// When the app comes back on screen, it checks whether the server has a newer one and reloads into it, but never in
// the middle of a search or a battle.

/**
 * Screens a reload would interrupt: picking a side, searching, the battle itself, the result screens (a rematch can be
 * waiting there), and a challenge waiting for its taker or being accepted.
 */
const BUSY = /^#\/(App1[0-9]|App21b|App22)$/;

function current(): string | null {
  return document.querySelector<HTMLScriptElement>('script[type="module"][src*="/assets/index-"]')?.src.split("/").pop() ?? null;
}

async function check(): Promise<void> {
  const mine = current();
  if (!mine || BUSY.test(location.hash)) return;
  const html = await fetch("/", { cache: "no-store" }).then((r) => r.text()).catch(() => null);
  const live = html?.match(/\/assets\/(index-[A-Za-z0-9_-]+\.js)/)?.[1];
  if (live && live !== mine) location.reload();
}

export function reloadWhenUpdated(): void {
  if (import.meta.env.DEV) return;
  addEventListener("visibilitychange", () => {
    if (document.visibilityState === "visible") void check();
  });
}
